/* eslint-disable react/require-default-props */
import React from 'react';
import {FlatList} from 'react-native';
import {get, isEmpty} from 'lodash';
import {noop} from 'lodash';

import LoadingIndicator from '/component/base/LoadingIndicator/LoadingIndicator';

import {TaskItem} from '../TaskItem';

import {usePreJourney} from './PreJourney.hook';
import {styles} from './PreJourney.style';

interface CheckIn {
  chkBoxCode?: string;
  checkStatus?: boolean;
}

interface PreJourneyTask {
  clientId?: number;
  screenTabCode?: string;
  checkIns?: CheckIn[];
}

interface Task {
  id?: string;
  checkStatus?: boolean;
}

interface PreJourneyProps {
  preJourneyInitialTasks?: Task[];
  preJourneyTasks?: PreJourneyTask[];
  fetchClientJourneyTask?: () => void;
  setClientJourneyTasks?: () => void;
  clientId?: number | null;
  onShowTaskDetail?: () => void;
  clientJourneyTimer?: number;
  hasPreJourneyTasks?: boolean;
  setClientJourneyState?: () => void;
}

/**
 * @param {object} params - Parameters
 * @param {Object[]} params.filteredTasks - an object that contains tile data (description)
 * @param {string}   params.filteredTasks.tabDescription
 * @param {string}   params.filteredTasks.screenTabCode
 * @param {Object[]} params.filteredTasks.checkBox
 * @param {string}   params.filteredTasks.checkBox.screenTabCode
 * @param {string}   params.filteredTasks.checkBox.chkBoxCode
 * @param {string}   params.filteredTasks.checkBox.description
 * @param {Object[]} params.preJourneyTasks - an object that contains data about the status of the checkbox
 * @param {number}   params.preJourneyTasks.clientId
 * @param {string}   params.preJourneyTasks.screenTabCode
 * @param {Object[]} params.preJourneyTasks.checkIns
 * @param {string}   params.preJourneyTasks.checkIns.chkBoxCode
 * @param {boolean}  params.preJourneyTasks.checkIns.checkStatus
 * @param {function} params.fetchClientJourneyTask - function for sending a post request to change the status of the checkbox
 * @param {function} params.setClientJourneyTasks - function for changing the status in the redux
 */

export const PreJourney: React.FC<PreJourneyProps> = ({
  preJourneyInitialTasks = [],
  preJourneyTasks = [],
  fetchClientJourneyTask = noop,
  setClientJourneyTasks = noop,
  clientId = null,
  onShowTaskDetail = noop,
  clientJourneyTimer = 6000,
  hasPreJourneyTasks = false,
  setClientJourneyState = noop,
}) => {
  const {tasks, onTaskStatusChange, getTaskItemIcon} = usePreJourney({
    preJourneyInitialTasks,
    preJourneyTasks,
    fetchClientJourneyTask,
    setClientJourneyTasks,
    clientId,
    onShowTaskDetail,
    clientJourneyTimer,
    setClientJourneyState,
  });
  const renderItem = (item: any) => {
    const checkStatus = get(item, 'item.checkStatus');

    return (
      <TaskItem
        taskItem={item}
        onTaskStatusChange={onTaskStatusChange}
        iconName={getTaskItemIcon(checkStatus)}
        isChecked={checkStatus}
        onShowTaskDetail={onShowTaskDetail}
      />
    );
  };

  // Preparing data for display
  if (isEmpty(tasks) && !hasPreJourneyTasks) {
    return <LoadingIndicator style={styles.loader} size="small" />;
  }

  return (
    <FlatList
      scrollEnabled={false}
      contentContainerStyle={styles.taskListContainer}
      data={tasks}
      // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
      keyExtractor={item => item.id}
      renderItem={renderItem}
    />
  );
};
